/**
 * IP18 EIS / Lineup — PC carousel caption sync.
 * Part 1 slides are whole images; this file does not split or animate them.
 */
(function () {
  'use strict';

  function syncCaption(root, swiper) {
    var titleEl = root.querySelector('[data-ip18-eis-caption-title]');
    var bodyEl = root.querySelector('[data-ip18-eis-caption-body]');
    if (!swiper || !titleEl) return;

    var slides = root.querySelectorAll('.ip18-eis__carousel .swiper-slide:not(.swiper-slide-duplicate)');
    var slide = slides[swiper.realIndex] || slides[swiper.activeIndex];
    if (!slide) return;

    var title = slide.getAttribute('data-caption-title') || '';
    var body = slide.getAttribute('data-caption-body') || '';
    titleEl.textContent = title;
    titleEl.style.visibility = title ? '' : 'hidden';
    if (bodyEl) {
      bodyEl.textContent = body;
      bodyEl.style.visibility = body ? '' : 'hidden';
    }
  }

  function bindEisCarousel(root) {
    var component = root.querySelector('swiper-component');
    if (!component) return;

    function attach(swiper) {
      if (!swiper || component._ip18EisBound) return;
      component._ip18EisBound = true;
      syncCaption(root, swiper);
      swiper.on('slideChange', function () {
        syncCaption(root, swiper);
      });
    }

    if (component.swiper) attach(component.swiper);

    document.addEventListener('swiper-component:ready', function (event) {
      var detail = event.detail;
      if (!detail || detail.swiperComponent !== component) return;
      attach(detail.swiper);
    });
  }

  document.querySelectorAll('[data-ip18-eis]').forEach(bindEisCarousel);
})();
